import type {
    Field,
    FieldValue,
    GeneratorConfigV1,
} from '../types/generator-config';
import { type Answers, visibleFields } from './visibility';

/** Valeur par défaut d'un field à l'initialisation du formulaire */
export function defaultValueForField(field: Field): FieldValue {
    switch (field.type) {
        case 'select':
            return field.defaultValue ?? null;
        case 'chips':
            if (field.multi) {
                return Array.isArray(field.defaultValue)
                    ? field.defaultValue
                    : field.defaultValue
                    ? [field.defaultValue]
                    : [];
            }
            return (field.defaultValue as string | undefined) ?? null;
        case 'radio':
            return field.defaultValue ?? null;
        case 'slider':
            return field.defaultValue ?? Math.round((field.min + field.max) / 2);
        case 'number':
            return field.defaultValue ?? null;
        case 'textarea':
            return field.defaultValue ?? '';
        case 'checkbox-group':
            return field.defaultValue ?? [];
    }
}

/** Initialise le record `answers` avec les valeurs par défaut de tous les fields */
export function initializeAnswers(config: GeneratorConfigV1): Answers {
    const answers: Answers = {};
    for (const step of config.steps) {
        for (const field of step.fields) {
            answers[field.id] = defaultValueForField(field);
        }
    }
    return answers;
}

/** Un field est-il vide (pas de réponse fournie) ? */
export function isFieldEmpty(value: FieldValue): boolean {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    return false;
}

/** Liste des IDs de fields requis non remplis pour une étape (en tenant compte de la visibilité) */
export function stepValidationErrors(
    fields: Field[],
    answers: Answers
): string[] {
    const visible = visibleFields(fields, answers);
    return visible
        .filter((f) => f.required && isFieldEmpty(answers[f.id]))
        .map((f) => f.id);
}
